import React, { useEffect, useState, lazy, Suspense } from 'react'
import { useParams, useNavigate, useOutletContext } from 'react-router-dom'
import { Empty, Spin, Tag } from 'antd'
import { ExportOutlined, MenuUnfoldOutlined, HomeOutlined } from '@ant-design/icons'
import { toolTabs } from '../../api'

const ToolsPage = lazy(() => import('./index'))
const PushCopyWorkbench = lazy(() => import('../operation/PushCopyWorkbench'))

interface Tab {
  id: number
  name: string
  url: string
  owner?: string
  description?: string
}

export default function ToolsTabPage() {
  const { tabId } = useParams()
  const navigate = useNavigate()
  const { collapsed, setCollapsed } = useOutletContext<{ collapsed: boolean; setCollapsed: (v: boolean) => void }>()
  const [tabs, setTabs] = useState<Tab[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    toolTabs.list().then((data: any) => {
      setTabs(data)
      if (data.length > 0 && !tabId) {
        navigate(`/tools/${data[0].id}`, { replace: true })
      }
    }).finally(() => setLoading(false))
  }, [])

  const activeTab = tabs.find(t => t.id === Number(tabId))

  if (loading) return <Spin style={{ display: 'block', margin: '100px auto' }} />

  const isBuiltinAI = activeTab?.url === '__builtin_ai'
  const isBuiltinPush = activeTab?.url === '__builtin_push_copy'
  const isIframe = activeTab && !isBuiltinAI && !isBuiltinPush

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: collapsed ? '100vh' : 'calc(100vh - 48px)' }}>
      {/* Top info bar */}
      {activeTab && (
        <div style={{
          background: '#fff', borderRadius: collapsed ? 0 : 10, padding: '10px 20px',
          marginBottom: collapsed ? 0 : 12,
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          boxShadow: '0 1px 4px rgba(0,0,0,0.04)', flexShrink: 0,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
            {collapsed && (
              <MenuUnfoldOutlined
                onClick={() => setCollapsed(false)}
                style={{ fontSize: 18, color: '#536DFE', cursor: 'pointer', flexShrink: 0 }}
              />
            )}
            <span style={{ fontSize: 15, fontWeight: 600, color: '#333', whiteSpace: 'nowrap' }}>{activeTab.name}</span>
            {activeTab.owner && <Tag color="blue" style={{ margin: 0 }}>负责人：{activeTab.owner}</Tag>}
            {activeTab.description && <span style={{ fontSize: 12, color: '#888', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{activeTab.description}</span>}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexShrink: 0 }}>
            {activeTab && (
              <a href={activeTab.url.startsWith('http') ? activeTab.url : window.location.href}
                target="_blank" rel="noopener noreferrer"
                style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 13, color: '#536DFE', whiteSpace: 'nowrap' }}>
                <ExportOutlined /> 新窗口打开
              </a>
            )}
            <HomeOutlined onClick={() => navigate('/')} style={{ fontSize: 18, color: '#536DFE', cursor: 'pointer' }} title="返回首页" />
          </div>
        </div>
      )}

      {/* Content */}
      <div style={{ borderRadius: collapsed ? 0 : 12, overflow: 'hidden', background: '#fff', boxShadow: collapsed ? 'none' : '0 2px 8px #E8EAFC' }}>
        {isBuiltinAI && (
          <div style={{ padding: 24, overflow: 'auto' }}>
            <Suspense fallback={<Spin />}><ToolsPage /></Suspense>
          </div>
        )}
        {isBuiltinPush && (
          <div style={{ padding: 24, overflow: 'auto' }}>
            <Suspense fallback={<Spin />}><PushCopyWorkbench /></Suspense>
          </div>
        )}
        {isIframe && (
          <iframe src={activeTab.url} title={activeTab.name} style={{ width: '100%', height: '4000px', border: 'none', display: 'block' }} />
        )}
        {!activeTab && <Empty description="请从左侧菜单选择工具" style={{ paddingTop: 120 }} />}
      </div>
    </div>
  )
}
